import { RedoAlert } from "@redotech/redo-web/arbiter-components/alert/redo-alert";
import { RedoTextInput } from "@redotech/redo-web/arbiter-components/input/redo-text-input";
import { RedoToggle } from "@redotech/redo-web/arbiter-components/toggle/redo-toggle";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { groupInput, input, InputSchema } from "@redotech/ui/form";
import { numberValidator } from "@redotech/ui/validators";
import { memo } from "react";

export const exchangeOutboundLabelCreditSettingsForm = groupInput({
  enabled: input<boolean>(),
  amount: input<string>({ validator: numberValidator({ min: 0 }) }),
});

export type ExchangeOutboundLabelCreditSettingsForm = InputSchema.Input<
  typeof exchangeOutboundLabelCreditSettingsForm
>;

export const ExchangeOutboundLabelCreditSettingsCard = memo(
  function ExchangeOutboundLabelCreditSettingsCard({
    input,
  }: {
    input: ExchangeOutboundLabelCreditSettingsForm;
  }) {
    return (
      <>
        <RedoAlert
          color="warning"
          description="Every processed exchange credits the merchant this amount at Redo's expense. Confirm the arrangement with finance before enabling."
          fullWidth
          size="sm"
          title="Finance approval required"
        />
        <Flex align="center" dir="row" gap="md" justify="space-between">
          <Flex dir="column" gap="xs" grow="1">
            <Text fontSize="sm" textColor="secondary">
              Redo covers the outbound shipping label for exchange orders. Each
              time an exchange is processed, the merchant is credited this fixed
              amount on their invoice as an Exchange outbound label credit.
            </Text>
          </Flex>
          <RedoToggle
            setValue={input.inputs.enabled.setValue}
            size="md"
            value={input.inputs.enabled.value}
          />
        </Flex>

        <Flex dir="column" gap="md">
          <RedoTextInput
            IconTrailing={() => <Text as="span">USD</Text>}
            label="Credit per exchange"
            min={0}
            placeholder="0.00"
            setValue={input.inputs.amount.setValue}
            state={!input.inputs.enabled.value ? "disabled" : "default"}
            step={0.01}
            value={input.inputs.amount.value}
          />
          {input.inputs.amount.errors.length > 0 && (
            <Text fontSize="xs" textColor="error">
              {input.inputs.amount.errors[0]}
            </Text>
          )}
        </Flex>
      </>
    );
  },
);
